





























































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DeliveryPackageGroup from '@/store/entities/grouping-packages/delivery-package-group';
    import _ from 'lodash';
import AppConsts from '../../../lib/appconst';

    class  PageUnitRequest extends PageRequest{
        keyword:string;
        status:string;
        from: Date;
        to: Date;
    }
    @Component({
        
    })
    export default class GroupingPackage extends AbpBase{
        namespace = 'deliveryPackageGroup';
        //filters
        pagerequest:PageUnitRequest=new PageUnitRequest();
        creationTime:Date[]=[];
        statuses = [];

        get list(){
          var re = this.$store.state.deliveryPackageGroup.list;
          var startIndex = (this.currentPage - 1) * this.pageSize;
          var index = 0;
          re.forEach(function(item) {
            item.orderNo = startIndex + index + 1;
            index++;
          });
          return re;
        }
        async getStatuses(){
          await this.$store.dispatch({
              type:'saleOrder/getSoStatusesForSelect',
                data: { hasAllItem: true}
          }).then(()=>{
            var re = _.filter(this.$store.state.saleOrder.soStatuses, (item) => {
              if(_.includes(AppConsts.statusesGroupPackage, item.code))
                return item;
            });
            this.pagerequest.status = re.length === 0 ? "" : re[0].code;
            this.statuses =  re;
          });
          
        }
        get loading(){
            return this.$store.state.deliveryPackageGroup.loading;
        }
        pageChange(page:number){
            this.$store.commit(`${this.namespace}/setCurrentPage`,page);
            this.getpage();
        }
        pagesizeChange(pagesize:number){
            this.$store.commit(`${this.namespace}/setPageSize`,pagesize);
            this.getpage();
        }
        async getpage(){
            this.pagerequest.maxResultCount=this.pageSize;
            this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
            //filters
            if (this.creationTime.length>0) {
                this.pagerequest.from=this.creationTime[0];
            }
            if (this.creationTime.length>1) {
                this.pagerequest.to=this.creationTime[1];
            }
            await this.$store.dispatch({
                type:`${this.namespace}/getAll`,
                data:this.pagerequest
            }).catch(() => {
              this.$store.commit(`${this.namespace}/setLoading`,false);
            });
        }
        get pageSize(){
            return this.$store.state.deliveryPackageGroup.pageSize;
        }
        get totalCount(){
            return this.$store.state.deliveryPackageGroup.totalCount;
        }
        get currentPage(){
            return this.$store.state.deliveryPackageGroup.currentPage;
        }

        createGroup(){
            this.$router.push({path: 'grouping-package/create'});
        }

        onView(code){
            this.$root.$router.push({name: 'grouping-package/view/:code', params: {code: code}});
        }

        onUpdate(code){
            this.$root.$router.push({name: 'grouping-package/update/:code', params: {code: code}});
        }
        
        columns=[
        {
            title:Util.L('Order'),
            key:'orderNo',
            align: 'center'
        },{
            title:Util.L('Code'),
            key:'id'
        },{
            title:Util.L('AoGroup'),
            key:'aoGroupCode'
        },{
            title:Util.L('PackageQty'),
            key:'sumPackage',
            align: "right"
        },{
            title:Util.L('Status'),
            key:'statusName'
        },{
            title:Util.L('CreatorUserName'),
            key:'creatorUserName'
        },{
            title:Util.L('CreationTime'),
            key:'creationTime',
            render:(h:any,params:any)=>{
                return h("span", Util.toViewDateString(params.row.creationTime));
            }
        },{
            title:Util.L('Action'),
            slot:'action',
            align: "center",
        }];

        viewDateWarning(){ 
          var argus = [AppConsts.reportRangeDays.range15.toString()];
          return Util.L('RangeDaysTooltip','',...argus);
        }

        async created(){
            this.getStatuses();
            this.creationTime = Util.buildDefaultViewDate(AppConsts.reportRangeDays.range15);
        }
    }
